import React, { useRef, useState } from 'react'
import { Button, Flexgrid, FlexgridItem, Form, WaitMessage } from '@wf-wfria/pioneer-core'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { ModalDialog } from './ModalDialog'
import { ForgotUserIdContractNumber } from './ForgotUserIdContractNumber'
import { ForgotUserIdContentInput } from './ForgotUserIdContentInput'
import { ForgotUserIdRicohContractNumber } from './ForgotUserIdRicohContractNumber'
import { onFocusUserIdInput } from './RegistrationForm'
import {
	DOCEX,
	WFORMS,
	RFI,
	ONBOARD,
	SBA,
	DLO,
	COBO,
	EASYCONNECT,
} from '../businessSegmentBrandIds'

export function ForgotUserIdFormContent({
	emailForgotUser,
	dob,
	emailForgotUserRef,
	dobForgotUserRef,
	formatMessage,
	forgotUserIdMessage,
	onUpdateInput,
	onFocusInput,
	onCustomTextInputValidator,
	contractNumber,
	mode,
	customerNumberRicohForgotUserId,
	contractNumberRicohForgotUserId,
	invoiceNumberRicohForgotUserId,
	contractOrInvoice,
	focusedElement,
	onSelectContractOrInvoice,
}) {
	const brandIdIsCCOrOnboardingOrLendMgmtOrRFI =
		mode === DOCEX ||
		mode === WFORMS ||
		mode === ONBOARD ||
		mode === SBA ||
		mode === RFI ||
		mode === DLO ||
		mode === COBO ||
		mode === EASYCONNECT
	const defaultEmailInputClasses = 'textField'
	const emailHasViolation = emailForgotUser.errorIds.length > 0
	const emailInputClasses = classNames(defaultEmailInputClasses, {
		HasInputViolation: emailHasViolation,
		'wf-row wf-col--mob-sm-12 wf-col--mob-12 wf-col--tab-4 wf-col--desk-4':
			!brandIdIsCCOrOnboardingOrLendMgmtOrRFI,
		'wf-row wf-col--8': brandIdIsCCOrOnboardingOrLendMgmtOrRFI,
	})

	const defaultLabelClassName = 'wf-col textAlignLeft'
	const defaultFieldClassName = 'wf-col textAlignLeft'

	const labelClassName = classNames(defaultLabelClassName, {
		'wf-col--6 wf-col--mob-only-12': brandIdIsCCOrOnboardingOrLendMgmtOrRFI,
		'wf-col--12 wf-col--mob-only-12': !brandIdIsCCOrOnboardingOrLendMgmtOrRFI,
	})

	const fieldClassName = classNames(defaultFieldClassName, {
		'wf-col--6 wf-col--mob-only-12': brandIdIsCCOrOnboardingOrLendMgmtOrRFI,
		'wf-col--12 wf-col--mob-only-12': !brandIdIsCCOrOnboardingOrLendMgmtOrRFI,
	})

	const defaultContractNumberInputClasses =
		'wf-col--mob-sm-12 wf-col--mob-12 wf-col--tab-4 wf-col--desk-4 textField'
	const contractNumberHasViolation = contractNumber.errorIds.length > 0
	const contractNumberInputClasses = classNames(
		defaultContractNumberInputClasses,
		{
			HasInputViolation: contractNumberHasViolation,
		},
	)

	const defaultCustomerNumberRicohInputClasses =
		'wf-col--mob-sm-12 wf-col--mob-12 wf-col--tab-4 wf-col--desk-4 textField'
	const customerNumberRicohHasViolations =
		customerNumberRicohForgotUserId.errorIds.length > 0
	const customerNumberRicohInputClasses = classNames(
		defaultCustomerNumberRicohInputClasses,
		{
			HasInputViolation: customerNumberRicohHasViolations,
		},
	)

	const defaultContractNumberRicohInputClasses =
		'wf-col--mob-sm-12 wf-col--mob-12 wf-col--tab-4 wf-col--desk-4 textField'
	const contractNumberRicohHasViolations =
		contractNumberRicohForgotUserId.errorIds.length > 0
	const contractNumberRicohInputClasses = classNames(
		defaultContractNumberRicohInputClasses,
		{
			HasInputViolation: contractNumberRicohHasViolations,
		},
	)

	const defaultInvoiceNumberInputClasses =
		'wf-col--mob-sm-12 wf-col--mob-12 wf-col--tab-4 wf-col--desk-4 textField'
	const invoiceNumberHasViolations =
		invoiceNumberRicohForgotUserId.errorIds.length > 0
	const invoiceNumberInputClasses = classNames(
		defaultInvoiceNumberInputClasses,
		{
			HasInputViolation: invoiceNumberHasViolations,
		},
	)

	function onTextInputValidator(elementId, inputValue) {
		return onCustomTextInputValidator(elementId, inputValue, formatMessage)
	}

	return (
		<Flexgrid rowGap={2} columnGap={2}>
			<FlexgridItem span={8}>
				<InstructionMessage
					brandIdIsCCOrOnboardingOrLendMgmtOrRFI={
						brandIdIsCCOrOnboardingOrLendMgmtOrRFI
					}
					formatMessage={formatMessage}
				/>
			</FlexgridItem>
			{/* <FlexgridItem span={8}  style={{marginBottom: '0px', marginTop: '0px'  }}>
			<p className="wf-u-form-required-indicator">
				<FormattedMessage id="ocra.create-user-id.required.field.label" />
			</p>
			</FlexgridItem> */}
			<FlexgridItem span={8}>
				<ForgotUserIdContentInput
					forgotUserIdMessage={forgotUserIdMessage}
					dob={dob}
					emailForgotUserRef={emailForgotUserRef}
					dobForgotUserRef={dobForgotUserRef}
					emailForgotUser={emailForgotUser}
					onTextInputValidator={onTextInputValidator}
					emailInputClasses={emailInputClasses}
					onFocusInput={onFocusInput}
					mode={mode}
					onUpdateInput={onUpdateInput}
					formatMessage={formatMessage}
					labelClassName={labelClassName}
					fieldClassName={fieldClassName}
				/>
			</FlexgridItem>
			<FlexgridItem span={8}>
				<ForgotUserIdContractNumber
					contractNumber={contractNumber}
					onTextInputValidator={onTextInputValidator}
					onUpdateInput={onUpdateInput}
					formatMessage={formatMessage}
					mode={mode}
					contractNumberInputClasses={contractNumberInputClasses}
				/>
			</FlexgridItem>
			<FlexgridItem span={8}>
				<ForgotUserIdRicohContractNumber
					customerNumberRicohForgotUserId={customerNumberRicohForgotUserId}
					contractNumberRicohForgotUserId={contractNumberRicohForgotUserId}
					onTextInputValidator={onTextInputValidator}
					invoiceNumberRicohForgotUserId={invoiceNumberRicohForgotUserId}
					onUpdateInput={onUpdateInput}
					formatMessage={formatMessage}
					mode={mode}
					customerNumberRicohInputClasses={customerNumberRicohInputClasses}
					contractNumberRicohInputClasses={contractNumberRicohInputClasses}
					invoiceNumberInputClasses={invoiceNumberInputClasses}
					contractOrInvoice={contractOrInvoice}
					focusedElement={focusedElement}
					onSelectContractOrInvoice={onSelectContractOrInvoice}
				/>
			</FlexgridItem>
		</Flexgrid>
	)
}

export function ForgotUserIdFormFooter({
	formatMessage,
	forgotUserIdMessage,
	onHideForgotUserId,
	isSubmitting,
}) {
	const { messageId } = forgotUserIdMessage

	return (
		<div>
			<Button
				className="ForgotUserIdFormFooterSubmitButton"
				kind="primary"
				disabled={messageId.includes('CLDP1029') || isSubmitting}
				type="submit"
			>
				{formatMessage({
					id: 'forgot-user-id-form.form-footer.button.submit.label',
				})}
			</Button>
			<Button
				className="ForgotUserIdFormFooterCancelButton"
				kind="chromeless"
				onClick={() => onHideForgotUserId()}
				disabled={isSubmitting}
			>
				{formatMessage({
					id: 'forgot-user-id-form.form-footer.button.cancel.label',
				})}
			</Button>
		</div>
	)
}

export function ForgotUserIdForm({
	emailForgotUser,
	dob,
	forgotUserIdMessage,
	showForgotUserIdForm,
	onGetUserId,
	onHideForgotUserId,
	onUpdateInput,
	onFocusInput,
	onBlurInput,
	onShowForgotUserIdMessage,
	onHideAllMessages,
	intl,
	onCustomTextInputValidator,
	contractNumber,
	mode,
	submitButtonDisabled,
	customerNumberRicohForgotUserId,
	contractNumberRicohForgotUserId,
	invoiceNumberRicohForgotUserId,
	contractOrInvoice,
	onSelectContractOrInvoice,
}) {
	const { formatMessage } = intl
	const formRef = useRef()
	const [isSubmitting, setIsSubmitting] = useState(false)

	function onSubmitButton() {
		const canSubmit = !submitButtonDisabled
		if (!canSubmit) {
			return null
		}
		setIsSubmitting(true)
		onFocusUserIdInput('#emailForgotUser')
		formRef.current.validateField('emailForgotUser')

		return Promise.resolve(onGetUserId())
			.then(() => {
				setIsSubmitting(false)
			})
			.catch(() => {
				setIsSubmitting(false)
			})
	}

	return (
		<ModalDialog
			onClose={onHideForgotUserId}
			title={formatMessage({
				id: 'forgot-user-id-form.modal-dialog.title',
			})}
			height={'450px'}
			width={'800px'}
			elementToFocusOnClose={'.ForgotUserIdButton'}
			open={showForgotUserIdForm}
		>
			{isSubmitting && (
				<WaitMessage
					render={() => (
						<span className={'ForgotUserIdFormLoadingMessage'}>
							Loading...
						</span>
					)}
				/>
			)}
			<Form action="#" ref={formRef} onSubmit={onSubmitButton}>
				<ForgotUserIdFormContent
					emailForgotUser={emailForgotUser}
					dob={dob}
					onHideForgotUserId={onHideForgotUserId}
					onUpdateInput={onUpdateInput}
					formatMessage={formatMessage}
					onFocusInput={onFocusInput}
					onBlurInput={onBlurInput}
					forgotUserIdMessage={forgotUserIdMessage}
					onShowForgotUserIdMessage={onShowForgotUserIdMessage}
					onHideAllMessages={onHideAllMessages}
					onCustomTextInputValidator={onCustomTextInputValidator}
					contractNumber={contractNumber}
					mode={mode}
					customerNumberRicohForgotUserId={customerNumberRicohForgotUserId}
					contractNumberRicohForgotUserId={contractNumberRicohForgotUserId}
					invoiceNumberRicohForgotUserId={invoiceNumberRicohForgotUserId}
					contractOrInvoice={contractOrInvoice}
					onSelectContractOrInvoice={onSelectContractOrInvoice}
				/>
				<ForgotUserIdFormFooter
					submitButtonDisabled={submitButtonDisabled}
					forgotUserIdMessage={forgotUserIdMessage}
					onGetUserId={onGetUserId}
					mode={mode}
					formatMessage={formatMessage}
					onHideForgotUserId={onHideForgotUserId}
					isSubmitting={isSubmitting}
				/>
			</Form>
		</ModalDialog>
	)
}

export function InstructionMessage({
	brandIdIsCCOrOnboardingOrLendMgmtOrRFI,
	formatMessage,
}) {
	if (brandIdIsCCOrOnboardingOrLendMgmtOrRFI) {
		return (
			<p>
				{formatMessage({
					id: 'forgot-user-id-form.form-content.instruction',
				})}
			</p>
		)
	}
	return (
		<p>
			{formatMessage({
				id: 'forgot-user-id-form.form-content.noncc.instruction',
			})}
		</p>
	)
}
